<template>
  <NuxtLink :to="toNuxtLink" class="activity-book-item d-flex">
    <div class="book-item-cover-wrapper">
      <BookCover
        :book-id="book.id"
        :publication="book"
        :cover-size="SMALL_THUMB"
        :lazy-load="lazyLoad"
      />
    </div>
    <div
      class="book-item-info-wrapper d-flex flex-column justify-space-between"
    >
      <div class="book-item-name-wrapper d-flex flex-column">
        <span class="book-item-name">{{ book.name }}</span>
        <span class="book-item-author">{{ book.author }}</span>
      </div>
      <div class="book-item-info d-flex">
        <div v-if="book.difficulty && showLevel" class="decryption-item">
          Lvl {{ book.difficulty }}
        </div>
        <div class="decryption-item">{{ bookCategoryLabel }}</div>
        <TimeDuration
          v-if="book.readingTime"
          :duration="book.readingTime"
          dir="auto"
          class-name="decryption-item"
        />
        <div v-if="book.audio" class="decryption-item">
          <img
            class="book-item-audio-ico"
            :src="bookItemAudio"
            alt="bookItemAudio"
          />
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script>
import { sizes as thumbSize } from '@shared/enums/ThumbSizesEnum';

import publicationUtils from '@/services/utils/publicationUtils';
import images from '@/assets/images';

import BookCover from '@/components/base/BookCover/BookCover.vue';
import TimeDuration from '@/components/base/TimeDuration/TimeDuration.vue';

export default {
  name: 'BookItem',
  components: {
    BookCover,
    TimeDuration
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    showLevel: {
      type: Boolean,
      default: true
    },
    lazyLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      SMALL_THUMB: thumbSize.SMALL,
      bookItemAudio: images.icoHeadset
    };
  },
  computed: {
    toNuxtLink() {
      return publicationUtils.getPublicationLink(this.book);
    },
    bookCategoryLabel() {
      return publicationUtils.getCategoryLocalizationKey(
        this.book.category,
        this.$t.bind(this)
      );
    }
  }
};
</script>

<style lang="less">
@import '@/assets/styles/base.less';

.activity-book-item {
  min-width: 0;
  gap: 16px;
  text-decoration: none;

  .book-item-cover-wrapper {
    width: 54px;
    height: 72px;
    flex-shrink: 0;

    & > div {
      width: 100%;
      height: 100%;
    }
  }
  .book-item-author,
  .book-item-info {
    font-weight: 500;
    color: #64748b;
  }
  &,
  .book-item-info-wrapper {
    font-size: 14px;
  }
  .book-item-info-wrapper,
  .book-item-name-wrapper {
    min-width: 0;
  }
  .book-item-name {
    font-weight: 700;
  }
  .book-item-name,
  .book-item-author {
    color: var(--black-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .book-item-info {
    white-space: nowrap;
    .decryption-item {
      display: flex;
      align-items: center;
      &:not(:first-child) {
        &:before {
          content: '•';
          margin: 0 0.3em;
          @media @narrow {
            margin: 0 0.1em;
          }
        }
      }
    }
    .book-item-audio-ico {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
